import axios from "axios";



const apiKey = process.env.REACT_APP_API_KEY;

console.log("API KEY:", apiKey);

// For enquiry API (configurable via .env)

export const enquiryApi = axios.create({
  baseURL: "https://sourceone.co.bw/api/v1/prime-precision-imaging",
  headers: {
     "X-Api-Key": apiKey,
  },
});

// Log every request
enquiryApi.interceptors.request.use((config) => {
  console.log(process.env.REACT_APP_API_KEY);
  console.log("=== Outgoing Request ===");
  console.log("URL:", config.baseURL + (config.url || ""));
  console.log("Method:", config.method);
  console.log("Headers:", config.headers);
  console.log("Data:", config.data);
  console.log("========================");
  return config;
});

// Log every response
enquiryApi.interceptors.response.use(
  (response) => {
    console.log("=== Response ===");
    console.log("Status:", response.status);
    console.log("Data:", response.data);
    console.log("================");
    return response;
  },
  (error) => {
    console.log("=== Response Error ===");
    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Data:", error.response.data);
    } else {
      console.log("Error:", error.message);
    }
    console.log("=======================");
    return Promise.reject(error);
  }
);



// For another API (hard‑coded or could also use another env var)
const api = axios.create({
  baseURL: "https://prime-precision-backend-server-il2j.onrender.com/api",
});

export default api;
